import { css } from "glamor";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { ICSSWithIndexer, GetSimpleHash, RemoveAnimationProperties } from "../CSS";
import { StyleCache } from "../StyleCache/StyleCache";

export function StyleClassAuto(CSS: ICSSWithIndexer) {
    const serializedCss = JSON.stringify(CSS);
    const label = GetSimpleHash(serializedCss);
    const cachedStyle = StyleCache.Lookup(label);

    if (cachedStyle) {
        return `${cachedStyle}`;
    }

    if (IsMobileDevice()) {
        RemoveAnimationProperties(CSS);
    }

    const cssStyle = css({ ...CSS, label });
    StyleCache.Add(label, cssStyle);

    return `${cssStyle}`;
}
